var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPromotionTicketRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 4a2 2 0 012 2v8h-.72c-.186 0-.37.026-.55.077-1.933.553-1.933 3.293 0 3.846.178.05.363.077.548.077H29v8a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2h22zM5 26h22v-6.21c-3.627-1.203-3.626-6.377 0-7.58V6H5v20zm17-2h-2v-4h2v4zm-5-4H8v-2h9v2zm5-2h-2v-4h2v4zm-5-4H8v-2h9v2zm5-2h-2V8h2v4z",
    fill: "#000"
  })));
}

export default SvgIconPromotionTicketRexOutline;